module.exports = "images/france-3.8daee2e2.png";